module.exports = __webpack_public_path__ + "static/media/naga_dice.11bfeb18.png";